/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-25 10:06:15
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-25 16:00:06
 * @FilePath: \hlweb2.0\src\pages\Solution\Archives\Carousel\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useRef } from "react";
import { Carousel } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import "./index.scss";
function ArchivesCase() {
  const { t } = useTranslation();
  const history = useHistory();
  const language = localStorage.getItem("i18nextLng");
  const archivesCaseCenter = t("solution_archives.archives5", {
    returnObjects: true,
  });
  const clickTo = () => {
    history.push(`/successStories`);
  };
  return (
    <div className="archives_case">
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{archivesCaseCenter.til}</div>
        </div>
      </div>
      <div className="case_con">
        <div className="case_item_left" style={{background: `url(${archivesCaseCenter.case1Url}) no-repeat center`,backgroundSize: 'cover'}}>
          <div className="case_item_left_model">
            <span onClick={()=>clickTo()}>{archivesCaseCenter.case1}&nbsp;</span>
            <span onClick={()=>clickTo()}>{"->"}</span>
          </div>
        </div>
        <div className="case_item_right">
          <span onClick={()=>clickTo()}>{archivesCaseCenter.case2}</span>
          <span onClick={()=>clickTo()}>{" ->"}</span>
        </div>
      </div>
    </div>
  );
}

export default ArchivesCase;
